// @ts-nocheck
import axios from 'axios';
import { BASE_URL } from '../../../../queries/useDataEngine';

export const TasksService = {
  getPendingTasks: (params, loader = false) =>
    axios
      .get(BASE_URL + '/model-entity/MyTask', {
        params,
        loader,
      })
      .then((res) => ({
        data: {
          data: res.data,
          headers: res.headers,
        },
      })),

  getTaskQueue: (params, loader = false) =>
    axios
      .get(BASE_URL + '/worker-queue', {
        params,
        loader,
      })
      .then((res) => ({
        data: {
          data: res.data,
          headers: res.headers,
        },
      })),

  getTaskQueueFilter: (params, loader = true) =>
    axios.get(BASE_URL + '/worker-queue-filter', {
      params,
      loader,
    }),

  getTaskResult: (params) =>
    axios.get(BASE_URL + '/get-single-task', {
      params,
    }),

  getOpenTasks: (params, loader = false) =>
    axios
      .get(BASE_URL + '/auth/openTasks', {
        params,
        loader,
      })
      .then((res) => ({
        data: {
          data: res.data,
          headers: res.headers,
        },
      })),

  retriggerAutomation: (payload) =>
    axios.post(BASE_URL + '/retrigger-send-mail', payload),
};
